export default function MountingComponent(bool,context){
    context.setState({
        componentStatus : bool
    })
}